import { render, staticRenderFns } from "./OnboardingChat.vue?vue&type=template&id=24289360&scoped=true"
import script from "./OnboardingChat.vue?vue&type=script&lang=js"
export * from "./OnboardingChat.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChat.vue?vue&type=style&index=0&id=24289360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24289360",
  null
  
)

export default component.exports